<template>
    <div class="">
        <Header v-on:headerToChild="onSearchSubmit"></Header>

        <!-- Main -->
        <main class="u-main">
            <Navigation :tenant="tenant_id"></Navigation>

            <div class="u-content">

                <div class="u-body min-h-700">
                    <h1 class="h2 mb-2 text-capitalize">{{ refs }}

                        <!-- Tenants -->
                        <div class="pull-rights ui-mt-15 pull-right">
                            <div class="dropdown">
                                <button type="button" 
                                    class="btn btn-dark btn-sm dropdown-toggle" 
                                    data-toggle="dropdown"
                                    aria-haspopup="true" 
                                    aria-expanded="false" 
                                    :disabled="tenantLoading">
                                    <span class="btn-icon ti-home mr-2"></span>
                                    <span v-if="!tenantLoading" class="ui-mr5"> {{ tenant_name }}</span>
                                    <span v-if="tenantLoading">
                                        <span class="spinner-grow spinner-grow-sm mr-1" 
                                            role="status" 
                                            aria-hidden="true">
                                        </span>Loading...
                                    </span>
                                </button>
                                <div class="dropdown-menu">
                                    <a v-if="auth.role == 'root'"
                                        class="dropdown-item dropdown-pad" 
                                        href="javascript:;"
                                        @click="changeTenant(0, 'All Tenants')"> All Tenants
                                    </a>
                                    <a class="dropdown-pad dropdown-item" 
                                        href="javascript:;"
                                        v-for="(tenant, index) in tenants"
                                        :key="index"
                                        :class="(tenant.authority) ? '' : 'hidden'"
                                        @click="changeTenant(tenant.id, tenant.name)"> 
                                           &nbsp; {{ tenant.name }} &nbsp;
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!-- End Tenants -->

                    </h1>

                    <!-- Breadcrumb -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'dashboard' }">Home</router-link>
                            </li>
                            <li class="breadcrumb-item text-capitalize active" aria-current="page">
                                {{ refs }}
                            </li>
                        </ol>
                    </nav>
                    <!-- End Breadcrumb -->

                    <!-- pgLoading -->
                    <div v-if="pgLoading" class="row h-100">
                        <div class="container text-center">
                            <div class="spinner-grow mt-5" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <!-- End pgLoading -->

                    <!-- Apps :class="(index > 3) ? 'pt-5' : ''"-->
                    <div v-if="!pgLoading" class="row">
                        <div class="col-md-3 pt-5" 
                            v-for="(row, index) in rows"
                            :key="index"
                            :class="(row.authority) ? '' : 'hidden'">
                            <div class="card text-center">
                                <div class="card-header">
                                    <h4>{{ row.name }}</h4>
                                </div>
                                
                                <div  v-if="row.tenant_id" class="card-body pt-0">
                                    <form @submit.prevent="addNew(row.id)" enctype="multipart/form-data" class="h-100">
                                        <!-- View in home -->
                                        <div class="form-group" style="text-align: start;">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    :id="(row.id) ? (row.id) + '_customSwitch2' : 'customSwitch2'"
                                                    :checked="row.view_in_home"
                                                    @click="onViewInHome(row.id)">
                                                <label class="custom-control-label" 
                                                    :for="(row.id) ? (row.id) + '_customSwitch2' : 'customSwitch2'"
                                                    v-html="(row.view_in_home) 
                                                        ? 'Show In Home' 
                                                        : 'Hide In Home'">
                                                </label>
                                            </div>
                                        </div>
                                        <!-- End View in home -->

                                        <!-- View in menu -->
                                        <div class="form-group" style="text-align: start;">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    :id="(row.id) ? (row.id) + '_customSwitch5' : 'customSwitch5'"
                                                    :checked="row.view_in_menu"
                                                    @click="onViewInMenu(row.id)">
                                                <label class="custom-control-label" 
                                                    :for="(row.id) ? (row.id) + '_customSwitch5' : 'customSwitch5'"
                                                    v-html="(row.view_in_menu) 
                                                        ? 'Show In Menu' 
                                                        : 'Hide In Menu'">
                                                </label>
                                            </div>
                                        </div>
                                        <!-- End View in menu -->

                                        <!-- Menu Order -->
                                            <div class="no-rpadding">
                                                <div class="form-group">
                                                    <input class="form-control"
                                                            v-bind:style="{display: orderDisplay[row.id]}"
                                                            placeholder="Order In Menu" 
                                                            :id="(row.id) ? (row.id) + '_inputText8' : 'inputText8'"
                                                            type="number"
                                                            min="0" 
                                                            v-model.number="row.menu_order">
                                                </div>
                                            </div>
                                            <!-- End Menu Order -->

                                        <!-- View in sub menu -->
                                        <div class="form-group" style="text-align: start;">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    :id="(row.id) ? (row.id) + '_customSwitch6' : 'customSwitch6'"
                                                    :checked="row.view_in_sub_menu"
                                                    @click="onViewInSubMenu(row.id)">
                                                <label class="custom-control-label" 
                                                    :for="(row.id) ? (row.id) + '_customSwitch6' : 'customSwitch6'"
                                                    v-html="(row.view_in_sub_menu) 
                                                        ? 'Show In Sub Menu' 
                                                        : 'Hide In Sub Menu'">
                                                </label>
                                            </div>
                                        </div>
                                        <!-- End View in sub menu -->
                                        <!--  Menu -->
                                        <div class="col-12 pt-3" style="text-align: start;">
                                            <div class="form-group">
                                                <div v-if="menuLoading" class="text-center">
                                                    <span class="spinner-grow spinner-grow-sm mr-1" 
                                                        role="status" 
                                                        aria-hidden="true">
                                                    </span>
                                                </div>
                                                <select v-bind:style="{display: inputDisplay[row.id]}" class="form-control custom-select"
                                                    v-if="!menuLoading" 
                                                    v-model="row.menu_id">
                                                    <option value="">Select Menu</option>
                                                    <option v-for="(menu, index) in menus" 
                                                            :key="index"
                                                            :value="menu.id">
                                                            {{ menu.title }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--  End Menu -->

                                        <div class="card-body pt-0" style="padding:0rem">
                                            <button class="btn btn-pill btn-with-icon text-uppercase btn-secondary">
                                                <span class="btn-icon mr-2 ti-pencil-alt"></span>
                                                <span class="text-capitalize"> Save </span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                                <div class="card-body pt-0">
                                    <span v-if="!row.setup"
                                        class="btn btn-pill btn-with-icon text-uppercase"
                                        :class="(row.setup) ? ' btn-secondary ' : ' btn-danger ' ">
                                        <span :class="'btn-icon mr-2 '+row.icon"></span>
                                        <span v-html="(row.setup) ? 'Update' : 'Set Up'">Update</span>
                                    </span>
                                    <router-link v-if="row.setup" :to="{ name: row.url }"
                                        class="btn btn-pill btn-with-icon text-uppercase"
                                        :class="(row.setup) ? ' btn-secondary ' : ' btn-danger ' ">
                                        <span :class="'btn-icon mr-2 '+row.icon"></span>
                                        <span v-html="(row.setup) ? 'View List' : 'Set Up'">View List</span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Apps -->


                </div>
            
            <Footer></Footer>
            
            </div>
        </main>
        <!-- End Main -->
    </div>
</template>

<script>
    import Header from '../layouts/Header.vue';
    import Navigation from '../layouts/Navigation';
    import Footer from '../layouts/Footer.vue';
    import iziToast from 'izitoast';
    
    export default {
        name: 'List',
        components: {
            Header,
            Navigation,
            Footer
        },
        data(){
            return {
                auth: { 
                    role: '',
                    access_token: '',
                },
                // 
                search: '',
                status: 1,
                pgLoading: true,
                rows: [],
                pagination: {},

                // Tenants
                tenant_id: 0,
                tenant_name: 'All Tenants',
                tenantLoading: true,
                tenants: [],

                refs: 'applications',
                // menu
                menus: [],
                menuLoading: true,
                inputDisplay: [],
                orderDisplay: [],
            }
        },
        mounted() {},
        watch: {
          $route() {
            //
          }
        },
        created() {
            // AccessToken & Role
            if(localStorage.getItem('role')) {
                this.auth.role = localStorage.getItem('role');
            }
            if(localStorage.getItem('access_token')) {
                this.auth.access_token = localStorage.getItem('access_token');
            }

            // Tenants
            if(localStorage.getItem('tenant_id')) {
                this.tenant_id = localStorage.getItem('tenant_id');
            }
            if(localStorage.getItem('tenant_name')) {
                this.tenant_name = localStorage.getItem('tenant_name');
            }

            this.fetchTenants();
        },
        methods: {


            // Add New
            addNew(id) {
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const config = { headers: { 'Content-Type': 'multipart/form-data' }}; 

                var rowData = [];
                var rowsArray = this.rows;
                rowsArray.forEach(function(row) {
                    if (row.id == id) {
                        rowData = row;
                        if (rowData.view_in_home == false) {
                            rowData.view_in_home = 0;
                        } else {
                            rowData.view_in_home = 1;
                        }

                        if (rowData.view_in_menu == false) {
                            rowData.view_in_menu = 0;
                        } else {
                            rowData.view_in_menu = 1;
                        }

                        if (rowData.view_in_sub_menu == false) {
                            rowData.view_in_sub_menu = 0;
                        } else {
                            rowData.view_in_sub_menu = 1;
                        }
                    }
                });
                this.fetchMenus();
                const options = {
                    url: window.baseURL+'/'+this.refs+'/'+id,
                    method: 'PUT',
                    data: {
                        id: id,
                        tenant_id: this.tenant_id,
                        name: rowData.name,
                        icon: rowData.icon,
                        setup: rowData.setup,
                        sort: rowData.sort ,
                        // status & visiblity
                        status: 1,
                        view_in_home: rowData.view_in_home,
                        view_in_menu: rowData.view_in_menu,
                        menu_order: rowData.menu_order,
                        view_in_sub_menu: rowData.view_in_sub_menu,
                        menu_id: rowData.menu_id,
                    }
                }
                this.axios(options, config)
                .then(() => {
                    this.btnLoading = false;
                    iziToast.success({
                        icon: 'ti-check',
                        title: 'Great job,',
                        message: 'Item Updated Successfully.',
                    });
                    this.$router.push({ name: this.refs })
                })
                .catch(err => {
                    // 403 Forbidden
                    if(err.response && err.response.status == 401) {
                        this.removeLocalStorage();
                        this.$router.push({ name: 'login' });
                    } else if(err.response && err.response.status == 403) {
                        this.$router.push({ name: 'forbidden' });
                    } else {
                        this.btnLoading = false;
                        iziToast.warning({
                            icon: 'ti-alert',
                            title: 'Wow-man,',
                            message: err.response.data.message
                        });
                    }
                })
                .finally(() => {})
                
            },
            // view in home
            onViewInHome(id){
                var rowsArray = this.rows;
                rowsArray.forEach(function(row, key) {
                    if (row.id == id) {
                        if(rowsArray[key].view_in_home) {
                            rowsArray[key].view_in_home = 0;
                        }
                        else {
                            rowsArray[key].view_in_home = 1;
                        }
                    }
                });
                this.rows = rowsArray;
            }, 
            // view in menu
            onViewInMenu(id){


                var rowsArray = this.rows;
                var orderDisplayArray = this.orderDisplay;
                rowsArray.forEach(function(row, key) {
                    if (row.id == id) {
                        if(rowsArray[key].view_in_menu) {
                            rowsArray[key].view_in_menu = 0;
                            orderDisplayArray[id] = 'none';
                        }
                        else {
                            rowsArray[key].view_in_menu = 1;
                            orderDisplayArray[id] = 'block';
                        }
                    }
                });
                this.rows = rowsArray;
                this.orderDisplay = orderDisplayArray;
            },

            // view in sub menu
            onViewInSubMenu(id){
                var rowsArray = this.rows;
                var inputDisplayArray = this.inputDisplay;
                rowsArray.forEach(function(row, key) {
                    if (row.id == id) {
                        if(rowsArray[key].view_in_sub_menu) {
                            rowsArray[key].view_in_sub_menu = 0;
                            inputDisplayArray[id] = 'none';
                        }
                        else {
                            rowsArray[key].view_in_sub_menu = 1;
                            inputDisplayArray[id] = 'block';
                        }
                    }
                });
                this.rows = rowsArray;
                this.inputDisplay = inputDisplayArray;
            },

            // fetchMenus
            fetchMenus() {
                this.menuLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/menus',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.menuLoading = false;
                    this.menus = res.data.rows;                    
                })
                .catch(() => {})
                .finally(() => {});
            },

            // on Search
            onSearchSubmit(value) {
                this.search = value;
                this.fetchData('', true);
            },

            // change Tenants
            changeTenant(id, name) {
                this.tenantLoading = true;
                this.tenant_id = id;
                this.tenant_name = name;
                localStorage.setItem('tenant_id', id);
                localStorage.setItem('tenant_name', name);
                this.fetchData('', true);
            },

            // fetch Tenants
            fetchTenants(){
                this.tenantLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/tenants',
                    method: 'GET',
                    data: {},
                    params: {
                        status: 'active',
                        paginate: 100
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.tenantLoading = false;
                        this.tenants = res.data.rows;

                        if(this.auth.role != 'root') {
                            if(!localStorage.getItem('tenant_id')) {
                                this.tenant_id = res.data.rows[0].id;
                                this.tenant_name = res.data.rows[0].name;
                            }
                        }

                        this.fetchData(); // fetch data
                    })
                    .catch(err => {
                        // 403 Forbidden
                        if(err.response && err.response.status == 401) {
                            this.removeLocalStorage();
                            this.$router.push({ name: 'login' });
                        } else if(err.response && err.response.status == 403) {
                            this.$router.push({ name: 'forbidden' });
                        } else {
                            this.btnLoading = false;
                            iziToast.warning({
                                icon: 'ti-alert',
                                title: 'Wow-man,',
                                message: (err.response) ? err.response.data.message : ''+err
                            });
                        }
                    })
                    .finally(() => {})
            },

            // fetch Data
            fetchData() {
                this.pgLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/'+this.refs,
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: this.status,
                        search: this.search,
                        paginate: 100,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.pgLoading = false;
                        this.tenantLoading = false;
                        this.rows = res.data.rows;
                        this.fetchMenus();
                        var rowsArray = this.rows;
                        var inputDisplayArray = this.inputDisplay;
                        var orderDisplayArray = this.orderDisplay;
                        rowsArray.forEach(function(row) {
                            if (row.view_in_sub_menu == 0) {
                                inputDisplayArray[row.id] = 'none';
                            } else {
                                inputDisplayArray[row.id] = 'block';
                            }

                            if (row.view_in_menu == 0) {
                                orderDisplayArray[row.id] = 'none';
                            } else {
                                orderDisplayArray[row.id] = 'block';
                            }
                        });
                    })
                    .catch(err => {
                        // 403 Forbidden
                        if(err.response && err.response.status == 401) {
                            this.removeLocalStorage();
                            this.$router.push({ name: 'login' });
                        } else if(err.response && err.response.status == 403) {
                            this.$router.push({ name: 'forbidden' });
                        } else {
                            this.btnLoading = false;
                            iziToast.warning({
                                icon: 'ti-alert',
                                title: 'Wow-man,',
                                message: (err.response) ? err.response.data.message : ''+err
                            });
                        }
                    })
                    .finally(() => {})
            },

            // remove sessions
            removeLocalStorage() {
                localStorage.removeItem('access_token');
                localStorage.removeItem('user_image');
                localStorage.removeItem('user_name');
                localStorage.removeItem('user_id');
                localStorage.removeItem('role');
            },

        },
    }
</script>
